import { buildCollection } from "@firecms/core";

export const cardStyleCollection = buildCollection({
  id: "card_style",
  name: "Card Style",
  path: "card_style",
  icon: "grid-on",
  group: "Style",
  textSearchEnabled: true,
  properties: {
    name: {
      dataType: "string",
      name: "Name",
      validation: {
        required: true,
      },
    },
    primary_color: {
      dataType: "string",
      name: "Primary Color [HEX]",

      validation: {
        required: true,
        matches: "^#([A-Fa-f0-9]{6})$",
        matchesMessage: "Color must be a valid hex code (ex. #FFFFFF)",
      },
    },
    horizontal_padding: {
      dataType: "number",
      name: "Horizontal Padding",
      description: "Horizontal padding in DIP",
      validation: {
        required: true,
        positive: true,
        integer: true,
        requiredMessage:
          "Must enter a non-negative, integer horizontal padding in DIP",
      },
    },
    vertical_padding: {
      dataType: "number",
      name: "Vertical Padding",
      description: "Vertical Padding in DIP",
      validation: {
        required: true,
        positive: true,
        integer: true,
        requiredMessage:
          "Must enter a non-negative, integer horizontal padding in DIP",
      },
    },
    margin: {
      dataType: "number",
      name: "Margin",
      description: "Margin in DIP",
      validation: {
        required: true,
        positive: true,
        integer: true,
        min: 0,
      },
    },
    tile_font_size: {
      dataType: "number",
      name: "Tile Font Size",
      description: "Font size in DIP",
      validation: {
        required: true,
        positive: true,
        integer: true,
        min: 0,
        requiredMessage: "Must enter a non-negative, integer font size in DIP",
      },
    },
    font_file: {
      dataType: "string",
      name: "Font File",
      description:
        "A OTF file of the font file (make sure the applicable license is included in the OTF file)",
      storage: {
        storagePath: "/font",
        acceptedFiles: [".ttf", ".otf"],
        maxSize: 1 * 1024 * 1024,
        fileName: "{rand}_{file}",
      },
      validation: {
        required: true,
      },
    },
    tiles: {
      dataType: "array",
      name: "Tiles",
      description: "Tiles to be displayed in the card",
      oneOf: {
        typeField: "type",
        valueField: "value",

        properties: {
          tile: {
            dataType: "map",
            name: "Tile",
            properties: {
              index: {
                dataType: "number",
                name: "Index",
                enumValues: {
                  "1": "1",
                  "2": "2",
                  "3": "3",
                  "4": "4",
                  "5": "5",
                  "6": "6",
                  "7": "7",
                  "8": "8",
                  "9": "9",
                  "10": "10",
                  "11": "11",
                  "12": "12",
                  "13": "13",
                  "14": "14",
                  "15": "15",
                  "16": "16",
                  "17": "17",
                  "18": "18",
                  "19": "19",
                  "20": "20",
                  "21": "21",
                  "22": "22",
                  "23": "23",
                  "24": "24",
                  "25": "25",
                },
              },
              background_color: {
                dataType: "string",
                name: "Background Color [HEX]",
                validation: {
                  required: true,
                  matches: "^#([A-Fa-f0-9]{6})$",
                  matchesMessage:
                    "Color must be a valid hex code (ex. #FFFFFF)",
                },
              },
              text_color: {
                dataType: "string",
                name: "Text Color [HEX]",
                validation: {
                  required: true,
                  matches: "^#([A-Fa-f0-9]{6})$",
                  matchesMessage:
                    "Color must be a valid hex code (ex. #FFFFFF)",
                },
              },
            },
          },
        },
      },
    },
  },
});
